import { computed, makeObservable } from "mobx";
import { DataCondition } from "../../../businessLayer";
import { generatePlayerURL } from "@draftkings/sportsbook-common-utils";
export class MarketboardState {
    constructor(options) {
        this.getMarketsGrid = (options) => this.parser.getMarketsGrid(options);
        this.getMarketsGridByH2H = (options) => {
            const { eventId, firstSubCategory, sectionName, eventStatus, leagueId } = options;
            const selectedSubCategory = this.parser.selectedSubCategoryByEventId.get(eventId);
            let id = firstSubCategory.id;
            let componentId = firstSubCategory.componentId;
            if (selectedSubCategory) {
                id = selectedSubCategory.id;
                componentId = selectedSubCategory.componentId;
            }
            return this.parser.getMarketsGrid({
                id,
                componentId,
                leagueId,
                eventId,
                eventStatus,
                sectionName,
            });
        };
        this.getPlayerLink = (eventData, data) => {
            if (data.playerId === this.playerId) {
                return "";
            }
            return generatePlayerURL({
                sport: eventData.sportName,
                league: eventData.leagueName,
                name: data.playerName,
                id: data.playerId,
                productConfig: this.productConfig,
            });
        };
        this.onPlayerLinkClick = (url) => {
            this.messageBus.emit("on_player_link_click", {
                url,
            });
        };
        this.condition = options.condition;
        this.parser = options.parser;
        this.uiConfig = {
            headerAnimation: options.headerAnimation,
            playerImage: options.playerImage,
            playerPageError: options.playerPageError,
            playerPagePlaceholder: options.playerPagePlaceholder,
            trackEvent: options.trackEvent,
            productConfig: options.productConfig,
        };
        this.dict = options.dict;
        this.locale = options.locale;
        this.milestonesComponentConfig = options.milestonesComponentConfig;
        this.productConfig = options.productConfig;
        this.getTeamLogo = options.getTeamLogo;
        this.playerPageConfig = {
            isPlayerImagesEnabled: !options.isPlayerImageDisabled,
            isPlayerPagesEnabled: true,
        };
        this.tabSwitcherController = options.tabSwitcherController;
        this.messageBus = options.messageBus;
        this.localizationConfig = options.localizationConfig;
        makeObservable(this, {
            events: computed,
            isError: computed,
            isEmpty: computed,
            isLoaded: computed,
            isLoading: computed,
            showOverlay: computed,
        });
    }
    activate() {
        this.parser.activate();
    }
    deactivate() {
        this.parser.deactivate();
    }
    loadData(playerId) {
        this.parser.loadData(playerId);
    }
    getPrePacks() {
        throw new Error("Method not implemented.");
    }
    addSelections(data) {
        this.parser.addSelections(data);
    }
    removeSelections(data) {
        this.parser.removeSelections(data);
    }
    setOddsStyle(oddsStyle) {
        this.parser.setOddsStyle(oddsStyle);
    }
    setParams(params) {
        this.parser.setParams(params);
    }
    get events() {
        return this.parser.events.filter(e => e.sections.length > 0);
    }
    get showOverlay() {
        return this.parser.showOverlay;
    }
    get playerId() {
        return this.parser.playerId;
    }
    get isError() { return this.condition.value === DataCondition.ERROR; }
    get isEmpty() { return this.condition.value === DataCondition.EMPTY || (this.events.length === 0 && this.condition.value === DataCondition.LOADED); }
    get isLoaded() { return this.condition.value === DataCondition.LOADED; }
    get isLoading() { return this.condition.value === DataCondition.LOADING; }
}
//# sourceMappingURL=MarketboardState.js.map